import { date, object, ref, string } from 'yup';
import { help, regularExpressions } from './properties';
import moment from 'moment';

const loginValidationSchema = object({
  email: string()
    .trim()
    .email(help.INVALID_EMAIL_ADDRESS)
    .matches(regularExpressions.EMAIL_REGEX, help.INVALID_EMAIL_ADDRESS)
    .required('email ' + help.VALUE_REQUIRED),
  password: string()
    .trim()
    .required('password ' + help.VALUE_REQUIRED)
});

const parentSignUpValidationSchema = object({
  firstName: string()
    .trim()
    .required('first name ' + help.VALUE_REQUIRED),
  lastName: string()
    .trim()
    .required('last name ' + help.VALUE_REQUIRED),
  email: string()
    .trim()
    .email(help.INVALID_EMAIL_ADDRESS)
    .matches(regularExpressions.EMAIL_REGEX, help.INVALID_EMAIL_ADDRESS)
    .required('email ' + help.VALUE_REQUIRED),
  countryId: string().required('country ' + help.SELECTION_REQUIRED),
  password: string()
    .trim()
    .matches(regularExpressions.PASSWORD_REGEX, help.PASSWORD_HELP)
    .required('password ' + help.VALUE_REQUIRED),
  confirmPassword: string()
    .trim()
    .oneOf([ref('password'), ''], help.PASSWORD_MISMATCH)
    .required('confirm password ' + help.VALUE_REQUIRED)
});

const resetPasswordModalValidationSchema = object({
  password: string()
    .matches(regularExpressions.PASSWORD_REGEX, help.PASSWORD_HELP)
    .required('Password ' + help.VALUE_REQUIRED),
  confirmPassword: string()
    .oneOf([ref('password'), ''], help.PASSWORD_MISMATCH)
    .required('Confirm password ' + help.VALUE_REQUIRED)
});

const hwsModalValidationSchema = object({
  password: string().required('Password ' + help.VALUE_REQUIRED)
});

const forgotPasswordValidationSchema = object({
  email: string()
    .trim()
    .email(help.INVALID_EMAIL_ADDRESS)
    .matches(regularExpressions.EMAIL_REGEX, help.INVALID_EMAIL_ADDRESS)
    .required('Email ' + help.VALUE_REQUIRED)
});

const verifyEmailValidationSchema = object({
  verificationCode: string()
    .trim()
    .required('Verification code ' + help.VALUE_REQUIRED)
});

const resetPasswordValidationSchema = object({
  password: string()
    .trim()
    .matches(regularExpressions.PASSWORD_REGEX, help.PASSWORD_HELP)
    .required('Password ' + help.VALUE_REQUIRED),
  confirmPassword: string()
    .trim()
    .oneOf([ref('password'), ''], help.PASSWORD_MISMATCH)
    .required('Confirm password ' + help.VALUE_REQUIRED)
});

const studentEditValidationSchema = object({
  firstName: string()
    .trim()
    .required('First name ' + help.VALUE_REQUIRED),
  lastName: string()
    .trim()
    .required('Last name ' + help.VALUE_REQUIRED),
  countryId: string().required('Country ' + help.SELECTION_REQUIRED),
  dateOfBirth: date()
    .test('age', 'You must be between 3 and 12 years old', function (value) {
      const dob = value;
      const age = moment().diff(dob, 'years');
      return age >= 3 && age <= 12;
    })
    .required('Date of birth' + ' ' + help.VALUE_REQUIRED),
  newPassword: string()
    .trim()
    .matches(regularExpressions.PASSWORD_REGEX, help.PASSWORD_HELP),
  confirmNewPassword: string()
    .trim()
    .oneOf([ref('newPassword'), ''], help.PASSWORD_MISMATCH)
    .when('newPassword', {
      is: (newPassword) => newPassword && newPassword.length > 0,
      then: string().required('Confirm password' + ' ' + help.VALUE_REQUIRED)
    })
});

const studentMyAccountEditValidationSchema = object({
  firstName: string()
    .trim()
    .required('first name' + ' ' + help.VALUE_REQUIRED),
  lastName: string()
    .trim()
    .required('last name' + ' ' + help.VALUE_REQUIRED),
  dateOfBirth: date()
    .test('age', 'You must be between 3 and 12 years old', function (value) {
      const dob = value;
      const age = moment().diff(dob, 'years');
      return age >= 3 && age <= 12;
    })
    .required('Date of birth' + ' ' + help.VALUE_REQUIRED),
  countryId: string().required('country' + ' ' + help.SELECTION_REQUIRED)
});

const parentMyAccountEditValidationSchema = object({
  firstName: string().required('first name' + ' ' + help.VALUE_REQUIRED),
  lastName: string().required('last name' + ' ' + help.VALUE_REQUIRED),
  countryId: string().required('country' + ' ' + help.SELECTION_REQUIRED),
  newPassword: string().matches(
    regularExpressions.PASSWORD_REGEX,
    help.PASSWORD_HELP
  ),
  confirmNewPassword: string().oneOf(
    [ref('newPassword'), ''],
    help.PASSWORD_MISMATCH
  )
});

const addStudentValidationSchema = object({
  firstName: string()
    .trim()
    .required('First name ' + help.VALUE_REQUIRED),
  lastName: string()
    .trim()
    .required('Last name ' + help.VALUE_REQUIRED),
  email: string()
    .trim()
    .email(help.INVALID_EMAIL_ADDRESS)
    .required('Email ' + help.VALUE_REQUIRED),
  dateOfBirth: date()
    .required('Date of birth ' + help.VALUE_REQUIRED)
    .test('age', 'You must be between 3 and 12 years old', function (value) {
      const dob = value;
      const age = moment().diff(dob, 'years');
      return age >= 3 && age <= 12;
    })
});

export {
  loginValidationSchema,
  parentSignUpValidationSchema,
  resetPasswordModalValidationSchema,
  hwsModalValidationSchema,
  forgotPasswordValidationSchema,
  verifyEmailValidationSchema,
  resetPasswordValidationSchema,
  studentEditValidationSchema,
  studentMyAccountEditValidationSchema,
  parentMyAccountEditValidationSchema,
  addStudentValidationSchema
};
